import React from 'react';

import dynamic from 'next/dynamic';

import { useBrand } from '@atc/brand';

const AtcTheme = dynamic(() => import('@/theme/AtcTheme'));
const KbbTheme = dynamic(() => import('@/theme/KbbTheme'));
const FordTheme = dynamic(() => import('@/theme/FordTheme'));
const CadTheme = dynamic(() => import('@/theme/CadTheme'));
const DemoTheme = dynamic(() => import('@/theme/DemoTheme'));
const PreviewAtcTheme = dynamic(() => import('@/theme/PreviewAtcTheme'));

export default function ThemeLoader() {

    const { brand, brands } = useBrand();

    switch (brand) {
        case brands.KBB_BRAND: {
            return <KbbTheme />;
        }

        case brands.FORD_BRAND: {
            return <FordTheme />;
        }

        case brands.CAR_AND_DRIVER: {
            return <CadTheme />;
        }

        case brands.DEMO_BRAND: {
            return <DemoTheme />;
        }

        case brands.PREVIEW_BRAND: {
            return <PreviewAtcTheme />;
        }

        case brands.ATC_BRAND:
        default: {
            return <AtcTheme />;
        }
    }
}
